/**
 *
 * WidgetResumen
 *
 */

// import PropTypes from 'prop-types';
import "./index.less"

import {
  HISTORICAL_ANALYSIS,
  ROLE_AMBASSADOR,
  ROLE_LEADER,
} from "utils/constants"
import {
  LOCAL_ACTIVE_ROL,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
  isModuleBySlug,
} from "../../utils/storage"
import { Progress, Spin, Tooltip } from "antd"
import React, { Fragment } from "react"

import Fade from "react-reveal/Fade"
import WidgetEmptyState from "components/WidgetEmptyState"
import WidgetHistoryEvolution from "../WidgetHistoryEvolution"
import { get, round } from "lodash"
import { loadTexts } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
class WidgetResumen extends React.Component {
  intl = loadTexts("dashboard")
  id = Math.random()
    .toString(36)
    .substr(2, 9)

  componentDidUpdate() {
    this.updateColorValue()
  }

  componentDidMount() {
    this.updateColorValue()
  }

  updateColorValue = () => {
    const { data } = this.props
    const value = document.querySelector(
      `#WidgetResumen_${this.id} .ant-progress-text`
    )
    if (value) value.style.color = get(data, "color", "black")
  }

  render() {
    const {
      data,
      isLoading,
      title,
      className,
      showEvolution,
      showHistoryWidget,
      dataHistory,
      hasLeader,
      withEmpty,
      calculationType
    } = this.props
    const { widthContainer, widthContainerPeakons } = this.props
    const anonymityCount = !validRole({ role: [5, 6] })
      ? LOCAL_ANONYMITY()
      : LOCAL_ANONYMITY_LEADERS()
    const anonymityValidate =
      get(data, "employees", 0) < parseInt(anonymityCount)

    const resultOrgRight =
      get(data, "percent", 0) -
      (this.props.isEngagement
        ? get(data, "engagement_org", 0)
        : get(data, "value_org", 0))
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const styleOnlyClimate =
      className === "WidgetResumenComponent boxShadow"
        ? {
            marginTop: 0,
            height: "100%",
            paddingTop: "2rem",
          }
        : {}
    const content = (
      <Fragment>
        <div
          className="WidgetResumenComponent-header subtitle_section"
          style={{ height: "100%" }}>
          {title}
          {get(data, "calculate_comparative.show", false) &&
            showEvolution &&
            isHistoricalAnalysis && (
              <div className="evolution">
                {showHistoryWidget ? (
                  <a onClick={showEvolution} className="btnHideEvolution">
                    {this.intl.resumeWidget.actions.hide} &lt;
                  </a>
                ) : (
                  <a onClick={showEvolution} className="btnShowEvolution">
                    {this.intl.resumeWidget.actions.evolution} &gt;
                  </a>
                )}
              </div>
            )}
        </div>
        {isLoading ? (
          <div className="loadingSpin">
            <Spin size="large" />
          </div>
        ) : withEmpty && anonymityValidate ? (
          <div style={{ maxWidth: 240, marginTop: 10 }}>
            <WidgetEmptyState description={this.intl.resumeWidget.emptyState} />
          </div>
        ) : (
          <div
            className="WidgetResumenComponent-body"
            style={
              ![ROLE_AMBASSADOR, ROLE_LEADER].includes(
                parseInt(LOCAL_ACTIVE_ROL())
              ) &&
              !(
                get(data, "calculate_comparative.show", false) ||
                isHistoricalAnalysis
              )
                ? {
                    gridTemplateColumns: "auto",
                    textAlign: "center",
                    ...styleOnlyClimate,
                  }
                : styleOnlyClimate
            }>
            <div>
              <Tooltip
                overlayClassName="tooltipWhite"
                placement="right"
                title={`${get(data, "employees", 0)} ${
                  this.intl.resumeWidget.employees
                }`}>
                <Progress
                  width={105}
                  format={(percent) => get(data, "value_visible", "n/a")}
                  strokeWidth={9}
                  strokeColor={get(data, "color", "black")}
                  type="circle"
                  id={`WidgetResumen_${this.id}`}
                  percent={(calculationType==1)? parseInt(get(data, "value_visible", "n/a")):round((get(data, "value_visible", "n/a") / 5) * 100)}
                  //percent={parseInt(get(data, "value_visible", "n/a"))}
                />
              </Tooltip>
            </div>

            <div
              className={
                (get(data, "calculate_comparative.show", false) &&
                  isHistoricalAnalysis) ||
                [ROLE_AMBASSADOR, ROLE_LEADER].includes(
                  parseInt(LOCAL_ACTIVE_ROL())
                )
                  ? "WidgetResumenComponent-body-right"
                  : null
              }>
              {get(data, "calculate_comparative.show", false) &&
                isHistoricalAnalysis && (
                  <div>
                    <b>{this.intl.resumeWidget.lastMeasure}</b>
                    <span>
                      {data.calculate_comparative.value}
                      {data.calculate_comparative.level === true ? (
                        <div className="arrow-up increase" />
                      ) : data.calculate_comparative.level === false ? (
                        <div className="arrow-up decrease" />
                      ) : null}
                    </span>
                  </div>
                )}

              {[ROLE_AMBASSADOR, ROLE_LEADER].includes(
                parseInt(LOCAL_ACTIVE_ROL())
              ) && (
                <div>
                  <b>{this.intl.resumeWidget.organization}</b>
                  <div className="ambassador-org">
                    <span>
                      {this.props.isEngagement
                        ? `${get(data, "engagement_org", 0)}%`
                        : `${get(data, "value_org", 0)}%`}
                    </span>

                    <span>
                      {" "}
                      {resultOrgRight !== 1 ? ~~resultOrgRight : resultOrgRight}
                      %
                      {resultOrgRight !== 1 &&
                        (~~resultOrgRight > 0 ? (
                          <div className="arrow-up increase" />
                        ) : ~~resultOrgRight !== 0 ? (
                          <div className="arrow-up decrease" />
                        ) : null)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </Fragment>
    )

    if (showHistoryWidget) {
      return (
        <div
          className={className}
          style={{ display: "inline-flex", alignItems: "normal" }}>
          <div
            className="WidgetResumenComponent"
            style={{
              paddingTop: 0,
              width: widthContainer,
              paddingRight: "20px",
            }}>
            {content}
          </div>
          <div
            style={{
              borderLeft: "1px solid #EDE9E9",
              width: widthContainerPeakons,
            }}>
            <Fade duration={2500}>
              <WidgetHistoryEvolution
                data={dataHistory}
                hasEngagement={data.flag && data.flag === "MTE"}
                hasLeader={hasLeader || false}
              />
            </Fade>
          </div>
        </div>
      )
    }
    return (
      <Fragment>
        {className && className !== "none" ? (
          <div className={className}>{content}</div>
        ) : (
          content
        )}
      </Fragment>
    )
  }
}

WidgetResumen.propTypes = {}
WidgetResumen.defaultProps = { withEmpty: false ,calculationType:1}

export default WidgetResumen
